import MasterICCardSettingForm from './MasterICCardSettingForm';

export default MasterICCardSettingForm;